// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__kDXB_","title":"Info_title__3jUxg","links":"Info_links__vKvqh","link":"Info_link__1DHOH","logo":"Info_logo__11Vn7"};